import Cookie from 'js-cookie';

const KEY_SUFFIX = 'kameda_project';

const KEYS = {
  IS_ALREADY_START: `is_already_start_${KEY_SUFFIX}`,
  IS_MUTE: `is_mute_${KEY_SUFFIX}`,
  IS_SHARE: `is_share_${KEY_SUFFIX}`,
  HIGHT_SCORE: `hight_score_${KEY_SUFFIX}`,
  TOTAL_HAPPY_TURN: `total_happy_turn_${KEY_SUFFIX}`
};

export default class CookieData {
  static get isAlreadyStart() {
    return Cookie.get(KEYS.IS_ALREADY_START) === 'true';
  }

  static get isMute() {
    return Cookie.get(KEYS.IS_MUTE) === 'true';
  }

  static get isShare() {
    return Cookie.get(KEYS.IS_SHARE) === 'true';
  }

  static get highScore() {
    const data = Cookie.get(KEYS.HIGHT_SCORE);
    return data ? parseInt(data) : 0;
  }

  static get totalHappyTurn() {
    const data = Cookie.get(KEYS.TOTAL_HAPPY_TURN);
    if (!data) return 0;
    const total = parseInt(data);
    return total > 99999 ? 99999 : total;
  }

  static setIsAlreadyStart(isAlreadyStart) {
    Cookie.set(KEYS.IS_ALREADY_START, isAlreadyStart, {
      expires: CookieData._getSemipermanent(),
      sameSite: 'lax'
    });
  }

  static setIsMute(isMute) {
    Cookie.set(KEYS.IS_MUTE, isMute, {
      expires: CookieData._getSemipermanent(),
      sameSite: 'lax'
    });
  }

  static setIsShare(isShare) {
    Cookie.set(KEYS.IS_SHARE, isShare, {
      expires: CookieData._getSemipermanent(),
      sameSite: 'lax'
    });
  }

  static setHighScore(score) {
    if (CookieData.highScore > score) return;
    CookieData._setHighScore(score);
  }

  static setTotalHappyTurn(total) {
    Cookie.set(KEYS.TOTAL_HAPPY_TURN, total, {
      expires: CookieData._getSemipermanent(),
      sameSite: 'lax'
    });
  }

  static addTotalHappyTurn(score) {
    const total = CookieData.totalHappyTurn + score;
    Cookie.set(KEYS.TOTAL_HAPPY_TURN, total, {
      expires: CookieData._getSemipermanent(),
      sameSite: 'lax'
    });
  }

  static resetRecord() {
    Cookie.remove(KEYS.IS_SHARE);
    Cookie.remove(KEYS.HIGHT_SCORE);
    Cookie.remove(KEYS.TOTAL_HAPPY_TURN);
  }

  static counterStop() {
    CookieData.setHighScore(99999);
    CookieData.setTotalHappyTurn(99999);
  }

  static setLevel(num) {
    switch (num) {
      case 1:
        CookieData._setHighScore(529);
        CookieData.setTotalHappyTurn(0);
        CookieData.setIsShare(false);
        break;
      case 2:
        CookieData._setHighScore(800);
        CookieData.setTotalHappyTurn(0);
        CookieData.setIsShare(false);
        break;
      case 3:
        CookieData._setHighScore(800);
        CookieData.setTotalHappyTurn(300);
        CookieData.setIsShare(false);
        break;
      case 4:
        CookieData._setHighScore(800);
        CookieData.setTotalHappyTurn(1000);
        CookieData.setIsShare(false);
        break;
      case 5:
        CookieData._setHighScore(800);
        CookieData.setTotalHappyTurn(2500);
        CookieData.setIsShare(false);
        break;
      case 6:
        CookieData._setHighScore(800);
        CookieData.setTotalHappyTurn(5000);
        CookieData.setIsShare(false);
        break;
      case 7:
        CookieData._setHighScore(800);
        CookieData.setTotalHappyTurn(5000);
        CookieData.setIsShare(true);
        break;
    }
  }

  static _setHighScore(score) {
    Cookie.set(KEYS.HIGHT_SCORE, score, {
      expires: CookieData._getSemipermanent(),
      sameSite: 'lax'
    });
  }

  static _getMidnight() {
    const now = new Date();
    return new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59
    );
  }

  static _getSemipermanent() {
    return new Date(2038, 0, 19, 3, 14, 7);
  }
}
